import { useEffect } from 'react'
import Step from './Step'
import TemplatePicker from './WhatsAppContent/TemplatePicker'
import TemplateEditor from './WhatsAppContent/TemplateEditor'
import './TextMessageContent.scoped.scss'

function WhatsAppContentShortDescriptor({ complete, body }) {
  return (
    <div>
      {complete && (
        <p className="no-margin-bottom" dangerouslySetInnerHTML={{ __html: body }}></p>
      )}
      {!complete && (
        <p className="incomplete no-margin-bottom">What does the WhatsApp message say?</p>
      )}
    </div>
  )
}

export default function WhatsAppContent() {
  const act = useAct()
  const {
    mergeTags,
    whatsAppTemplates,
    currentEditor,
    renderedContent,
    templateRenderError,
  } = useSel((s) => s.campaignBuilder)
  const { whatsappTemplateId, interpolations, defaultInterpolations } = useSel(
    (s) => s.campaign.textMessageBlast
  )

  const activeWhatsAppTemplates = whatsAppTemplates.filter((t) => t.discardedAt === null)
  const whatsappTemplate = whatsAppTemplates.find((t) => t.id === whatsappTemplateId)
  const editing = currentEditor === 'text'
  const complete = whatsappTemplateId && _.every(_.values(interpolations), (v) => !!v)

  useEffect(() => {
    act.campaignBuilder.loadWhatsAppTemplates()
  }, [])

  useEffect(() => {
    act.campaignBuilder.renderTemplate()
  }, [whatsappTemplateId, JSON.stringify(interpolations)])

  const body = whatsappTemplate?.body
  let prettyBody = '<p>' + (body || '').replaceAll('\n', '</p><p>') + '</p>'
  for (const [slug, tag] of Object.entries(mergeTags)) {
    prettyBody = prettyBody.replaceAll(
      `{{${slug}}}`,
      `<span class="merge-tag">${tag}</span>`
    )
  }

  function clearTemplate() {
    act.campaign.upsertTextMessageBlast({
      body: null,
      whatsappTemplateId: null,
      interpolations: {},
    })
  }

  function selectTemplate(template) {
    const defaultInterpolations = Object.keys(template.interpolations || {}).reduce((acc, key) => {
      acc[key] = ''
      return acc
    }, {})
    act.campaign.upsertTextMessageBlast({
      body: template.body,
      whatsappTemplateId: template.id,
      interpolations: defaultInterpolations,
      defaultInterpolations: template.interpolations,
    })
  }

  function upsertInterpolation(key, value) {
    act.campaign.upsertTextMessageBlast({
      interpolations: { ...interpolations, [key]: value },
    })
  }

  return (
    <Step
      name="Content"
      editor="text"
      complete={complete}
      canClickFinish={complete}
      shortDescriptor={
        <WhatsAppContentShortDescriptor complete={complete} body={prettyBody} />
      }
    >
      <div>
        {!whatsappTemplateId && (
          <TemplatePicker
            templates={activeWhatsAppTemplates}
            onSelectTemplate={selectTemplate}
          />
        )}
      </div>

      {whatsappTemplate && (
        <TemplateEditor
          template={whatsappTemplate}
          interpolations={interpolations}
          defaultInterpolations={defaultInterpolations}
          renderedContent={renderedContent}
          templateRenderError={templateRenderError}
          mergeTags={mergeTags}
          editing={editing}
          onClearTemplate={clearTemplate}
          onUpsertInterpolation={upsertInterpolation}
        />
      )}
    </Step>
  )
}
